import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from '../../../../../Components/CustomInput';
import CustomSelect from "../../../../../Components/CustomSelect";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "inherit",
    color: "#232323",
    fontSize: "16px",
    fontFamily: "Open Sans",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
    },
  },
  dialog_title: {
    "& h6": {
      fontWeight: "700"
    }
  }
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageTemplate(props) {
  console.log("props=====", props.moduleId)
  const classes = useStyles();
  const dispatch = useDispatch();
  const { action, handleClose, data } = props;
  const [feildName, setFeildName] = useState("");
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [openWarning, setOpenWarning] = useState("");
  const [feildValue, setFeildValue] = useState([]);

  const [userData, setUserData] = useState([]);

  useEffect(() => {

    // setFeildValue(data.module_form_fields);
    if (action === "edit") {
      console.log(`data`, data)
      setUserData({
        ...userData,
        name: data.name,
        description: data.description
      });
    }
  }, [feildValue]);
  const setOpen = () => {
    setOpenNewFeild("open");
    setOpenNewFeildDialog(true);
  };
  const handleNewFeildClose = () => {
    setOpenNewFeildDialog(false);
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    console.log(selectedItemValue, inputId);
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const handleCreate = () => {
    const formData = new FormData();
    formData.append("name", userData.name);
    formData.append("description", userData.description);
    setLoading(true);
    DataService.createData(formData, "organisation_metrics_create")
      .then((res) => {
        if (res.success) {
          handleClose(res.data);
          dispatch(showSnackbar("success", ["Organization Metric added successfully!"], 5000));
          props.moduleSetup();
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleUpdate = () => {

    const formData = new FormData();
    formData.append("name", userData.name);
    formData.append("description", userData.description);
    formData.append("id", data.id);

    DataService.updateData(formData, data.id, "organisation_metrics")
      .then((res) => {
        console.log(`res`, res)
        if (res.success) {
          props.moduleSetup();
          dispatch(showSnackbar("success", ["Organization Metric updated successfully!"], 5000));
          handleClose(res.data);
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleDelete = () => {
    setLoading(true);
    DataService.getDirectData(`/organisation_metrics/list_organisations/?id=` + props.moduleId, {}).then((res) => {
      if (res.data.filter(e => e.active === true).length > 0) {
        dispatch(showSnackbar("error", ["Organization metric cannot be deleted as it’s already in use!"], 5000));
        setLoading(false);
      } else {
        const formData = new FormData();
        formData.append("id", data.id);
        DataService.deleteDirectFeild(`/organisation_metrics/` + data.id, formData)
          .then((res) => {
            if (res.success) {
              handleNewFeildClose(res.data);
              dispatch(showSnackbar("success", ["Organization Metric deleted successfully!"], 5000));
              props.moduleSetup();
            }
          })
          .catch(() => {
            setLoading(false);
          });
      }
    })
  };
  const setInputState = (inputStateValue, inputId) => {

    setUserData({ ...userData, [inputId]: inputStateValue })
  }
  const handleCreateNewFeild = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setLoading(true);
    DataService.createData({ module_id: props.moduleId, ...userData }, "module_setups_new_feild")
      .then((res) => {
        if (res.success) {
          handleNewFeildClose(res.data);

          props.moduleSetup();
          // message.showToastMessage({ open: true, message: "New Supplier added successfully", variant: "success" });
          //   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ? res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try Again", variant: "error" });
        setLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
    } else if (action === "edit") {

      handleUpdate(formData);
    }
  };

  return (
    <div>
      <Dialog maxWidth={"sm"} style={{
        height: '70%',
      }} open={true} onClose={handleClose} aria-labelledby="base-station-manage"      >
        <DialogTitle id="customized-dialog-title" className={classes.dialog_title} >
          <Typography style={{
            fontSize: "18px",
            fontFamily: "Open Sans",
            fontWeight: 700
          }}>
            {
              action === "edit" &&
              <IconButton className={classes.iconButton} onClick={handleClose} aria-label="menu">
                <ArrowBackIcon />
              </IconButton>
            }
            {action === "edit" ? "Edit organizational metric" : ""}
            {action === "create" ? "Add new organizational metric" : ''}
            {action === "delete" ? data.name : ''}</Typography>
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: '0px auto' }}>
          {
            action !== "delete" ?
              <div className={classes.formWrapper}>
                <form onSubmit={handleSubmit}>
                  {
                    action === "edit"
                      ? <React.Fragment>
                        <Grid container spacing={1} alignItems={"center"} justify={"flex-start"} style={{ marginBottom: 10 }}>
                          <Grid item xs={3}>
                            <Typography className={classes.title}>Metric name</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <CustomInput variant="outlined" placeholder="Metric name" id="name" autoFocus InputLabelProps={{ shrink: true }} required value={userData.name ?? ''} parentcall={setInputState} />
                          </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems={"center"} justify={"flex-start"}>
                          <Grid item xs={3}>
                            <Typography className={classes.title} >Description</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <CustomInput variant="outlined" placeholder="Description" InputLabelProps={{ shrink: true }} id="description" multiline={true} row={8} rowsMax={8} parentcall={setInputState} required value={userData.description ?? ''} />
                          </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems={"center"} justify={"center"} style={{ marginTop: 20 }}                   >
                          <Grid item xs={5} justify={"center"}>
                            <Button disableElevation type="submit" disabled={loading} variant={"contained"} style={{ textTransform: "none" }} color="secondary">
                              Update metric
                            </Button>
                          </Grid>
                        </Grid>
                      </React.Fragment>
                      : ""
                  }
                  <div>
                    {
                      action === "create"
                        ? <>
                          <Grid container spacing={1} alignItems={"center"} justify={"flex-start"} style={{ marginBottom: 10 }}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle2" color="primary" className={classes.title}>Metric name</Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <CustomInput variant="outlined" id="name" placeholder="Metric name" autoFocus InputLabelProps={{ shrink: true }} required value={userData.name} parentcall={setInputState} />
                            </Grid>
                          </Grid>
                          <Grid container spacing={1} alignItems={"center"} justify={"flex-start"}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle2" color="primary" className={classes.title} >Description</Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <CustomInput variant="outlined" InputLabelProps={{ shrink: true }} placeholder="Description" id="description" multiline={true} row={8} rowsMax={8} parentcall={setInputState} required value={userData.description} />
                            </Grid>
                          </Grid>
                          <Grid container spacing={1} alignItems={"center"} justify={"flex-end"} style={{ marginTop: 20 }}                   >
                            <Grid item xs={3}>
                              <Button disableElevation disabled={loading} type="button" variant={"contained"} onClick={handleClose} style={{ textTransform: "none" }}>Cancel</Button>
                            </Grid>
                            <Grid item xs={3}>
                              <Button disableElevation disabled={loading} type="submit" variant={"contained"} color="secondary" style={{ textTransform: "none" }}>
                                {action === "create" ? "Save" : "Update"}
                              </Button>
                            </Grid>
                          </Grid>
                        </>
                        : ''
                    }

                  </div>
                </form>
              </div>
              : <div className={classes.formWrapper}>
                Warning, Deleting this module will delete both the module and
                their items from the ordering list. Are you sure?
                <div className={classes.actionButtons}>
                  <Button disableElevation disabled={loading} type="button" variant={"contained"} onClick={handleClose} style={{ textTransform: "none" }}>
                    Cancel
                  </Button>
                  <Button disableElevation disabled={loading} type="button" variant={"contained"} color="secondary" onClick={handleDelete} style={{ textTransform: "none" }}>
                    Yes, Confirm
                  </Button>
                </div>
              </div>
          }
        </DialogContent>
      </Dialog>

    </div>
  )
}

export default ManageTemplate;
